import debounce from 'Utils/Debounce';
import ScrollPos from 'Utils/ScrollPos';

class TileCounter {
	countState = 0;

	constructor(el) {
		this.el = el;

		this.updateCounter = ::this.updateCounter;
		this.heartbeat = ::this.heartbeat;
		this.onHover = ::this.onHover;
		this.onTouchStart = ::this.onTouchStart;
		this.onTouchEnd = ::this.onTouchEnd;
		this.onScroll = debounce(::this.onScroll, 250);

		this.collectTiles();
		this.collectTileCounter();

		window.addEventListener('scroll', this.onScroll);
		this.onScroll();
	}

	onScroll(e) {
		if (this.countState === 0) {
			const rect = this.el.getBoundingClientRect();
			const isInViewport =
				(rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
					rect.top >= 0) ||
				(rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
					rect.bottom >= 0);

			isInViewport && this.startCounter();
		}

		if (this.countState === 1) {
			this.tileCounter.forEach(tile => {
				if (!tile.active) {
					const rect = tile.el.getBoundingClientRect();
					const isInViewport =
						rect.top >= 0 &&
						rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);

					tile.active = isInViewport;
				}
			});
		}
	}

	onHover(e) {
		this.tiles.forEach(item => item.parentNode.classList.remove('is-active'));
		e.currentTarget.parentNode.classList.add('is-active');
	}

	onTouchStart(e) {
		const el = e.currentTarget;
		this.startTouchPos = ScrollPos.get().top;
		this.currentEL = el;
		el.removeEventListener('touchstart', this.onTouchStart);
		el.addEventListener('touchend', this.onTouchEnd);
	}

	onTouchEnd(e) {
		const currentPos = ScrollPos.get().top;
		this.currentEL.addEventListener('touchstart', this.onTouchStart);
		this.currentEL.removeEventListener('touchend', this.onTouchEnd);

		if (Math.abs(currentPos - this.startTouchPos) < 10) {
			this.onHover({ currentTarget: this.currentEL });
		}
	}

	collectTiles() {
		this.tiles = Array.from(this.el.querySelectorAll('.js-itemTile')).map(el => {
			el.addEventListener('mouseover', this.onHover);
			el.addEventListener('touchstart', this.onTouchStart);
			return el;
		});
	}

	collectTileCounter() {
		this.tileCounter = Array.from(this.el.querySelectorAll('.js-tileCounterNumber')).map(el => {
			el.addEventListener('mouse_over', this.onHover);
			el.addEventListener('touch_start', this.onHover);

			let dataNumber = Number(el.getAttribute('data-number').replace(/,/g, '.'));

			return {
				el,
				active: false,
				target: dataNumber || 0,
				originalTarget: el.getAttribute('data-number'),
				text: el.getAttribute('data-number-text') || '|#|',
				current: String(0)
					.split('')
					.map(v => +v),
			};
		});
	}

	startCounter() {
		if (this.countState !== 0) return;
		this.countState = 1;

		this.heartbeat();
	}

	heartbeat() {
		const requestUpdate = this.tileCounter.reduce((prev, cur) => {
			const response = this.updateCounter(cur);
			if (response || prev) return true;
			return false;
		}, false);
		requestUpdate && window.requestAnimationFrame(this.heartbeat);
		if (!requestUpdate) {
			window.removeEventListener('scroll', this.onScroll);
		}
	}

	updateCounter(item) {
		const { el, target, text, active, originalTarget } = item;
		if (!active) return true;

		let { current } = item;

		const targetSplit = String(parseInt(target))
			.split('')
			.map(v => +v);

		while (current.length < targetSplit.length) {
			current.unshift(0);
		}

		current = current.map((currentNum, i) => {
			const targetInt = targetSplit[i];
			currentNum += (targetInt - currentNum) * 0.05;
			if (targetInt - currentNum < 0.1) currentNum = targetInt;
			return currentNum;
		});

		const currentSplitRounded = current.map(Math.floor);
		const currentNum = parseInt(currentSplitRounded.join(''));
		if (target - currentNum > 1) {
			item.current = current;
			el.innerText = text.replace('|#|', currentSplitRounded.join(''));
			return true;
		} else {
			item.current = targetSplit;
			el.innerText = text.replace('|#|', originalTarget);
		}

		return false;
	}
}

Array.from(document.querySelectorAll('.js-tileCounter')).forEach(el => new TileCounter(el));
